// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import React, { ReactElement } from 'react';

import './CircleLogo.scss';

interface CircleLogoProps {
    imageName: string;
    status: 'success' | 'warning' | 'error' | 'disabled';
    className?: string;
    onClick?: () => void;
}

const CircleLogo = ({ imageName, status, className, onClick }: CircleLogoProps): ReactElement => (
    <span className={classList('circle-logo')} onClick={onClick}>
        <img
            src={`static/images/${imageName}.svg`}
            alt={imageName}
            className={classList('circle-logo__image', className, {
                [status]: status,
            })}
        />
    </span>
);

export default CircleLogo;
